import React, { useCallback } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import ComponentPreview from "../../components/ComponentPreview";
import ComponentEditorControls from "../../components/ComponentEditorControls";

// Accept config, dispatch, and onOpenIconPicker as props
const ComponentCreatorView = ({ config, dispatch, onOpenIconPicker }) => {
	const handleOpenIconPicker = useCallback(
		(callback) => {
			onOpenIconPicker((selectedIcon) => {
				// Update the component config with the selected icon
				dispatch((prev) => ({
					...prev,
					icon: selectedIcon,
				}));
			});
		},
		[dispatch, onOpenIconPicker]
	);

	return (
		<View style={styles.container}>
			<View style={styles.previewArea}>
				{/* Center the preview visually */}
				<View style={styles.previewWrapper}>
					{/* ComponentPreview now uses the config from props */}
					<ComponentPreview config={config} />
				</View>
			</View>
			<ScrollView style={styles.controlsArea}>
				{/* Pass config, dispatch, and onOpenIconPicker down to controls */}
				<ComponentEditorControls config={config} dispatch={dispatch} onOpenIconPicker={handleOpenIconPicker} />
			</ScrollView>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		flex: 1,
		flexDirection: "row",
		backgroundColor: "#1E1E1E", // Slightly different background
	},
	previewArea: {
		flex: 2, // Give more space to preview
		justifyContent: "center",
		alignItems: "center",
		padding: 20,
		borderRightWidth: 1,
		borderRightColor: "#333",
		backgroundColor: "#1A1A1A", // Match modal background if needed
	},
	previewWrapper: {
		// Optional: Add constraints or background to the wrapper if needed
	},
	controlsArea: {
		flex: 1, // Less space for controls
		backgroundColor: "#1E1E1E",
	},
});

export default ComponentCreatorView;
